// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__37TNd","right":"Footer_right__SpYBR","buttons":"Footer_buttons__33GKg"};